import { motion } from "framer-motion";
import { colors2, icons } from "oolib";
import React from "react";
const { CaretDown } = icons;

export const RotatingCaret = ({ position = "down", opacity = 1, iconSize = 12, color = colors2.grey40 }) => {
  return (
    <motion.div
      style={{
        display:
          "flex" /**this helps to align the Caret properly within this div */,
      }}
      initial={{ opacity: 1, rotate: position === "up" ? 0 : 0 }}
      animate={{ opacity, rotate: position === "up" ? 180 : 0 }}
      
      transition={{ type: "tween", ease: "easeOut" }}
    >
      <CaretDown size={iconSize} weight="bold" style={{ color }}/>
    </motion.div>
  );
};
